<div class="loading" *ngIf="isLoading">Loading&#8230;</div>
<h4>
    <fa name="user"></fa> {{userMessageName}} - Messages
</h4>
<div id="gridContainer">
    <ag-grid-angular style="width: 100%; height: calc(100% - 17px)" [enableColResize]="true" [paginationAutoPageSize]="true" [pagination]="true" class="ag-theme-alpine" [rowData]="rows" [columnDefs]="columnDefs" [enableSorting]="true" [enableFilter]="true"
        [suppressHorizontalScroll]="true" (columnResized)="onColumnResized($event)" (gridReady)="onGridReady($event)" [overlayNoRowsTemplate]='noDataText'>
    </ag-grid-angular>
</div>